import type { Cents } from "@/types/pricing.type";

/**
 * Whole-percent discount of `current` against the `original` anchor, nearest
 * integer. The one formula behind every "X% OFF" badge — the catalog's through
 * `PricingService.getDiscountPercentage`, the upsell's directly off its own
 * table, per currency at render time (SHO-770): the PM's per-currency grid
 * doesn't follow one ratio, so one stored badge string would be off by a point
 * or two in half the currencies. The caller guarantees `original > 0`.
 *
 * Side-effect free on purpose — the upsell table and its unit test import it,
 * and neither should pull `pricingService`'s graph (Amplitude, the auth store)
 * for one line of arithmetic.
 */
export const getDiscountPercent = (current: Cents, original: Cents): number =>
  Math.round(((original - current) / original) * 100);
